import "../../../styles/HelpModal.css";

import React, { useState } from "react";

import Label from "../../atoms/Label";

function HelpModal({ isOpen, onClose, sections }) {
	const [expandedSections, setExpandedSections] = useState(new Set(sections?.map((s) => s.id)));

	if (!isOpen) return null;

	const toggleSection = (sectionId) => {
		setExpandedSections((prev) => {
			const newSet = new Set(prev);
			if (newSet.has(sectionId)) {
				newSet.delete(sectionId);
			} else {
				newSet.add(sectionId);
			}
			return newSet;
		});
	};

	const expandAll = () => {
		setExpandedSections(new Set(sections?.map((s) => s.id)));
	};

	const collapseAll = () => {
		setExpandedSections(new Set());
	};

	return (
		<div className='modal-overlay'>
			<div className='modal'>
				<div className='modal-header'>
					<Label
						label='Help'
						fontSize='16px'
						fontWeight='700'
						color='#000000'
						textAlign='left'
						padding='0px'
					/>
					<div className='header-controls'>
						<button className='btn' onClick={collapseAll}>
							Collapse
						</button>
						<button className='btn' onClick={expandAll}>
							Expand
						</button>
						<button className='close-btn' onClick={onClose}>
							×
						</button>
					</div>
				</div>

				<div className='modal-content'>
					<div className='help-modal-container'>
						{sections?.map((section) => (
							<div key={section.id} className='modal-section'>
								<div
									className='section-header'
									onClick={() => toggleSection(section.id)}>
									<Label
										label={section.title}
										fontSize='16px'
										fontWeight='700'
										color='#000000'
										textAlign='left'
										padding='10px'
									/>
									<button className='toggle-btn'>
										{expandedSections.has(section.id) ? "−" : "+"}
									</button>
								</div>
								{expandedSections.has(section.id) && (
									<div className='section-content'>
										<Label
											label={section.content}
											fontSize='14px'
											fontWeight='400'
											color='#000000'
											textAlign='left'
										/>
									</div>
								)}
							</div>
						))}
					</div>
				</div>

				<div className='modal-footer'>
					<button className='close-btn-large' onClick={onClose}>
						Close
					</button>
				</div>
			</div>
		</div>
	);
}

export default HelpModal;
